import React from "react";
import { StyleSheet, View, Image } from "react-native";
import { MonoText } from "./StyledText.js";
import { backendUrl } from "../constants/Environment.js";
import { useWindowDimensions } from "react-native";
import { AppDataContext } from "../context/AppDataProvider.js";

var styles = StyleSheet.create({
  item: {
    flex: 1,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    height: 256,
    minHeight: 256,
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,

    textShadowColor: "#585858",
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 0,
  },
  itemLarge: {
    flex: 1,
    flexDirection: "row",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    height: 180,
    minHeight: 180,
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    textShadowColor: "#585858",
    textShadowOffset: { width: 0, height: 0 },
    textShadowRadius: 0,
  },
});

const ArticleItem = (props) => {
  const { width } = useWindowDimensions();
  const { colors } = React.useContext(AppDataContext);

  if (!colors) {
    return <View></View>;
  }

  if (!props) {
    return <View></View>;
  }

  if (width > 1000) {
    /**
     * Desktop/laptop/bigger tablet
     */
    return (
      <View
        style={{
          justifyContent: "center",
          marginLeft: "auto",
          marginRight: "auto",
          width: 974,
        }}
      >
        <View
          style={{
            height: 180,
            maxHeight: 180,
            marginBottom: 24,
            backgroundColor: colors.tertiary,
          }}
          contentContainerStyle={{ flex: 1 }}
        >
          <View style={styles.itemLarge}>
            <Image
              style={{
                flex: 1,
                maxWidth: 320,
              }}
              source={{
                uri: `${backendUrl}/article/view-image/${props.item.id}`,
              }}
            ></Image>
            <View
              style={{
                flex: 1,
                flexDirection: "column",
                marginLeft: 16,
                marginTop: 8,
              }}
            >
              <MonoText
                style={{
                  color: "green",
                  fontSize: 12,
                }}
              >
                {props.item.category
                  ? props.item.category.category_name
                  : "Uncategorised"}
              </MonoText>
              <MonoText
                style={{
                  color: colors.text,
                  fontSize: 18,
                  fontWeight: "bold",
                }}
              >
                {props.item.headline}
              </MonoText>
              <MonoText
                style={{
                  color: colors.text,
                  fontSize: 9,
                  marginLeft: 2,
                  fontWeight: "bold",
                }}
              >
                {timeDifference(new Date(), new Date(props.item.createdAt))}
              </MonoText>
              <MonoText
                style={{
                  shadowColor: "#000",
                  shadowOffset: {
                    width: 0,
                    height: 0,
                  },
                  elevation: 0,
                  shadowOpacity: 0,
                  shadowRadius: 0,
                  fontSize: 12,
                  marginTop: 18,
                  textShadowColor: "#585858",
                  textShadowOffset: { width: 0, height: 0 },
                  textShadowRadius: 0,
                  elevation: 1,
                  color: colors.text,
                }}
              >
                {props.item.summary ? props.item.summary : "Read more..."}
              </MonoText>
            </View>
          </View>
        </View>
      </View>
    );
  } else if (width > 500) {
    /**
     * Non-mobile
     */
    return (
      <View
        style={{
          height: 180,
          maxHeight: 180,
          marginBottom: 24,
        }}
        contentContainerStyle={{ flex: 1 }}
      >
        <View style={styles.itemLarge}>
          <Image
            style={{
              flex: 1,
              maxWidth: 320,
            }}
            source={{
              uri: `${backendUrl}/article/view-image/${props.item.id}`,
            }}
          ></Image>
          <View
            style={{
              flex: 1,
              flexDirection: "column",
              marginLeft: 16,
              marginTop: 8,
            }}
          >
            <MonoText
              style={{
                color: "green",
                fontSize: 12,
              }}
            >
              {props.item.category
                ? props.item.category.category_name
                : "Uncategorised"}
            </MonoText>
            <MonoText
              style={{
                color: colors.text,
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              {props.item.headline}
            </MonoText>
            <MonoText
              style={{
                color: colors.text,
                fontSize: 9,
                marginLeft: 2,
                fontWeight: "bold",
              }}
            >
              {timeDifference(new Date(), new Date(props.item.createdAt))}
            </MonoText>
            <MonoText
              style={{
                shadowColor: "#000",
                shadowOffset: {
                  width: 0,
                  height: 0,
                },
                elevation: 0,
                shadowOpacity: 0,
                shadowRadius: 0,
                marginTop: 18,
                fontSize: 12,
                textShadowColor: "#585858",
                textShadowOffset: { width: 0, height: 0 },
                textShadowRadius: 0,
                elevation: 1,
                color: colors.text,
              }}
            >
              {props.item.summary ? props.item.summary : "Read more..."}
            </MonoText>
          </View>
        </View>
      </View>
    );
  }

  function timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = current - previous;

    if (elapsed < msPerMinute) {
      return Math.round(elapsed / 1000) + " seconds ago";
    } else if (elapsed < msPerHour) {
      return Math.round(elapsed / msPerMinute) + " minutes ago";
    } else if (elapsed < msPerDay) {
      return Math.round(elapsed / msPerHour) + " hours ago";
    } else if (elapsed < msPerMonth) {
      return "" + Math.round(elapsed / msPerDay) + " days ago";
    } else if (elapsed < msPerYear) {
      return "" + Math.round(elapsed / msPerMonth) + " months ago";
    } else {
      return "" + Math.round(elapsed / msPerYear) + " years ago";
    }
  }

  return (
    <View
      style={{
        // height: 360,
        // maxHeight: 360,
        marginBottom: 12,
      }}
      contentContainerStyle={{ flex: 1 }}
    >
      <View style={styles.item}>
        <Image
          style={{
            flex: 1,
          }}
          source={{
            uri: `${backendUrl}/article/view-image/${props.item.id}`,
          }}
        ></Image>
      </View>
      <View
        style={{
          flex: 1,
          flexDirection: "column",
          marginLeft: 16,
          marginTop: 8,
        }}
      >
        <MonoText
          style={{
            color: "green",
            fontSize: 12,
          }}
        >
          {props.item.category
            ? props.item.category.category_name
            : "Uncategorised"}
        </MonoText>
        <MonoText
          style={{
            color: colors.text,
            fontSize: 18,
            fontWeight: "bold",
          }}
        >
          {props.item.headline}
        </MonoText>
        <MonoText
          style={{
            color: colors.text,
            fontSize: 9,
            marginLeft: 2,
            fontWeight: "bold",
          }}
        >
          {timeDifference(new Date(), new Date(props.item.createdAt))}
        </MonoText>
        <MonoText
          style={{
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 0,
            },
            elevation: 0,
            shadowOpacity: 0,
            shadowRadius: 0,
            fontSize: 12,
            textShadowColor: "#585858",
            textShadowOffset: { width: 0, height: 0 },
            textShadowRadius: 0,
            elevation: 1,
            marginTop: 18,
            color: colors.text,
          }}
        >
          {props.item.summary ? props.item.summary : "Read more..."}
        </MonoText>
      </View>
    </View>
  );
};

export default ArticleItem;
